import React, { useEffect, useState, useRef, useContext } from 'react';
import { Toast } from 'primereact/toast';
import Form from 'react-bootstrap/Form';
import './order-list.css';
import { BreadCrumb } from 'primereact/breadcrumb';
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
// import MapIcon from '../../assets/icons/map.svg';
import { Dialog } from 'primereact/dialog';
import { Divider } from 'primereact/divider';
import MapComponent from '../MapComponent';
import { getFavoriteList } from '../../utils/api';
import moment from 'jalali-moment';
import Loadr from '../loader/loader';
import LoaderPage from '../loader/dotloader';
import { Accordion } from 'react-bootstrap'
import useToastNotification from '../../hooks/useToastNotification';
import AllOrder from './allOrder'
import OpenOrder from './openOrder'
import { TabView, TabPanel } from 'primereact/tabview';

//icon
import Basket from '../../assets/icons/order/basket.svg'
import BasketBold from '../../assets/icons/order/basket-bold.svg'


function OrderList() { // Receive onProfileLoad as a prop
    const [loading, setLoading] = useState(false);
    const [activeIndex, setActiveIndex] = useState(0);
    // const [favoriteList, setFavoriteList] = useState([]);
    // const { showError, showSuccess } = useToastNotification();

    // const fetchFavoriteList = async (id) => {
    //     try {
    //         setLoading(true)
    //         let res = await getFavoriteList(id)
    //         if (res.data != null) {
    //             setFavoriteList(res.data)
    //             setLoading(false)
    //         } else {
    //             setLoading(false)
    //         }

    //     } catch (error) {
    //         showError('خطا در برقرای ارتباط...')

    //     } finally {
    //         setLoading(false)
    //     }
    // }

    // useEffect(() => {
    //     let customerDatares = window.localStorage.getItem('userInfo');
    //     fetchFavoriteList(JSON.parse(customerDatares).si)

    // }, [])

    return (
        <>
            {loading && <LoaderPage isLoading={loading} />}

            <div className='profile-card'>
                <h6 className='page-title mb-4 mt-3'>سفارشات</h6>

                <div className="flex mb-2 tab-ticket justify-content-start">
                    <button
                        onClick={() => { setActiveIndex(0) }}
                        className="btn rounded-0"
                        style={activeIndex !== 0 ? { borderBottom: '0' } : { borderBottom: '2px solid #00a14b' }}
                    >
                        <img src={activeIndex == 0 ? BasketBold : Basket} alt="" /> همه سفارشات
                    </button>
                    <button
                        onClick={() => { setActiveIndex(1) }}
                        className="btn rounded-0"
                        style={activeIndex !== 1 ? { borderBottom: '0' } : { borderBottom: '2px solid #00a14b' }}
                    >
                        <img src={activeIndex == 1 ? BasketBold : Basket} alt="" /> سفارش های باز
                    </button>

                </div>
                <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)} >

                    <TabPanel>
                        <AllOrder />
                    </TabPanel>
                    <TabPanel>
                        <OpenOrder />
                    </TabPanel>
                </TabView>
            </div>

        </>
    );
}

export default OrderList;
